export const QUERY_KEYS = {
    //TODO rename for same spelling like: send_message: 'send-message'
    fetchMessages: 'fetchMessages',
    fetchChannels: 'fetchChannels',
    fetchChannelDetails: 'fetchChannelDetails',
    fetchAnimationDetails: 'fetchAnimationDetails',
    getUnlockedMediaMessage: 'getUnlockedMediaMessage',
    report_categories: 'report-categories',
    fetchChannelDetailsV3: 'fetchChannelDetailsV3',
    fetchUnreadMessageCountV3: 'fetchUnreadMessageCountV3',
    getGroupListV3: 'getGroupListV3',
    getBroadcastMessagesV3: 'getBroadcastMessagesV3',
    getUnreadMessageCountRepresentativeV3: 'getUnreadMessageCountRepresentativeV3'
}

export const MUTATION_KEYS = {
    send_file: 'send-file',
    sendGroupFileV3: 'sendGroupFileV3',
    sendBroadcastFileV3: 'sendBroadcastFileV3',
    send_message: 'send-message',
    send_chat_report: 'send-chat-report',
    sendBroadcastMessage: 'sendBroadcastMessage',
    createBroadcast: 'createBroadcast',
    unlockTextMessage: 'unlockTextMessage',
    unlockTextMessageV3: 'unlockTextMessageV3',
    unlockMediaMessageV3: 'unlockMediaMessageV3',
    takeOver: 'take-over',
    sendGroupMessageV3: 'sendGroupMessageV3',
    removeMessageV3: 'removeMessage',
    createChatWithoutMessage: 'createChatWithoutMessage'
}
